import React from "react";
import { Box, IconButton, TableCell, TableRow, Typography, useMediaQuery } from "@mui/material";
import UserImg from '../../common/assests/reyleafLogo.svg'
import BlockIcon from "../../common/assests/blockIcon.png";
import EyeIcon from "../../common/assests/eyegreen.png";
import LockIcon from "../../common/assests/lockicons.png";
import DeletIcon from "../../common/assests/deleticon.png";
import Adminimg from "../../common/assests/adminimg.png";
import configuration from "../../config/Config";

const AllVenderRow = ({ row,handleviewMore,deleteVender,blockVender,resumeVender }) => {
    const isSmallScreen = useMediaQuery("(max-width:480px)")
  const getStatusLabel = (status) => {
    switch (status) {
      case 1:
        return 'Unverified';
      case 2:
        return 'Active';
      case 3:
        return 'Blocked';
      case 4:
        return 'Deleted';
      case 5:
        return 'Rejected';
      default:
        return '-';
    }
  };

  return (
    <TableRow
      key={row?._id}
      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
    >
      <TableCell>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <img
            src={
              row?.picture
                ? `${configuration.cdnFront}/${row.picture}`
                : UserImg
            }
            alt={row?.fullname || "User"}
            style={{
              height: "45px",
              width: "45px",
              marginRight: "8px",
              borderRadius: "50%",
            }}
          />
          <Typography sx={{ opacity: row?.account_status === 3 ? 0.6 : 1 ,whiteSpace:'nowrap'}}>
            {row?.fullname || "-"}
          </Typography>
        </Box>
      </TableCell>
      <TableCell sx={{ opacity: row?.account_status === 3 ? 0.6 : 1 }}>
        {row?.email || "-"}
      </TableCell>
      <TableCell sx={{ opacity: row?.account_status === 3 ? 0.6 : 1 }}>
        {row?.phone || "-"}
      </TableCell>
      <TableCell sx={{ opacity: row?.account_status === 3 ? 0.6 : 1 }}>
        {row?.bankdetail || "-"}
      </TableCell>
      <TableCell sx={{ opacity: row?.account_status === 3 ? 0.6 : 1 }}>
        {getStatusLabel(row?.account_status)}
      </TableCell>
      <TableCell sx={{ opacity: row?.account_status === 3 ? 0.6 : 1 ,whiteSpace:'nowrap'}}>
        {[
          row?.address?.address || "-",
          // row?.address?.city || "",
          // row?.address?.state || "",
          // row?.address?.country || "",
          // row?.address?.zipcode || ""
        ]
          .filter(Boolean)
          .join(", ")}
      </TableCell>
      <TableCell sx={{ opacity: row?.account_status === 3 ? 0.6 : 1 }}>
        {row?.createdAt
          ? new Date(row?.createdAt).toLocaleDateString("en-US")
          : "-"}
      </TableCell>
      <TableCell
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          minHeight: "110px",
        }}
      >
        <IconButton onClick={handleviewMore}>
          <img
            src={EyeIcon}
            alt="viewicon"
            style={{
              height: isSmallScreen ? "35px" : "42px",
              width: isSmallScreen ? "35px" : "45px",
            }}
          />
        </IconButton>
        <IconButton
          onClick={row?.account_status === 3 ? resumeVender : blockVender}
        >
          {row?.account_status === 3 ? (
            <img
              src={BlockIcon}
              alt="unlockicon"
              style={{
                height: isSmallScreen ? "35px" : "42px",
                width: isSmallScreen ? "35px" : "45px",
              }}
            />
          ) : (
            <img
              src={LockIcon}
              alt="lockicon"
              style={{
                height: isSmallScreen ? "35px" : "42px",
                width: isSmallScreen ? "35px" : "45px",
              }}
            />
          )}
        </IconButton>
        <IconButton onClick={deleteVender}>
          <img
            src={DeletIcon}
            alt="viewicon"
            style={{
              height: isSmallScreen ? "35px" : "42px",
              width: isSmallScreen ? "35px" : "45px",
            }}
          />
        </IconButton>
      </TableCell>
    </TableRow>
  );
};

export default AllVenderRow;
